/**
 * Logger del front. En producción NO imprime nada de depuración y los errores
 * salen sin el objeto (que suele traer la respuesta del API, ids, tokens…):
 * cualquiera con la consola abierta veía datos de clientes. En desarrollo se
 * comporta como console.
 */
const isProd = process.env.NODE_ENV === 'production';

const logger = {
  log: isProd ? () => {} : (...args) => console.log(...args),
  warn: isProd ? () => {} : (...args) => console.warn(...args),
  error: isProd
    ? (message, err) => {
        // Solo el mensaje y, si hay, el status HTTP: suficiente para soporte, sin datos.
        const status = err?.response?.status;
        console.error(status ? `${message} (HTTP ${status})` : message);
      }
    : (...args) => console.error(...args),
};

export default logger;
